/**
 * How a folder is being read right now — per folder, browser-local.
 *
 * Not a fact about the folder, so it may not become vault data: the phone has
 * no opinion about whether the thoughts of the folders inside join this one's.
 *
 * `deeper` is deliberately ONE bit shared with the rail's scope `+deeper`
 * rather than two controls that mean the same thing — opening a folder is
 * scope of one, and the page's "Include their thoughts" is that folder's own
 * depth flag seen from the inside.
 */

const DEEP_KEY = 'folders.deeper';

function readMap(key: string): Record<string, string> {
  try {
    const raw = localStorage.getItem(key);
    return raw ? (JSON.parse(raw) as Record<string, string>) : {};
  } catch {
    return {};
  }
}

function writeMap(key: string, map: Record<string, string>): void {
  try {
    localStorage.setItem(key, JSON.stringify(map));
  } catch {
    /* storage unavailable; the control still works within the session */
  }
}

export function readDeeper(folderId: string): boolean {
  return readMap(DEEP_KEY)[folderId] === '1';
}

export function writeDeeper(folderId: string, deeper: boolean): void {
  const map = readMap(DEEP_KEY);
  if (deeper) map[folderId] = '1';
  else delete map[folderId];
  writeMap(DEEP_KEY, map);
}
